import { defineRule, configure } from 'vee-validate'
import { required, min, max, min_value, numeric, one_of, confirmed, email, regex } from '@vee-validate/rules'
import { localize } from '@vee-validate/i18n'
import i18n from '@/plugins/i18n'
import { type i18nTranslation, PrefixTranslationsEnum } from '@/common/types/i18n'
import { entityCodeRule, numberRule } from '@/common/helpers/fields/rules'
import { phoneRule } from '@/plugins/veevalidate/rules'

type CustomRuleDefinition = {
  prefix: string
  key: string
  rule: (value: unknown, params: unknown) => boolean
}

const CUSTOM_RULES = {
  email: {
    prefix: 'field',
    key: 'assist.field.error.valid',
    rule: email,
  },
  number: {
    prefix: 'field',
    key: 'assist.field.error.valid',
    rule: numberRule,
  },
  regex: {
    prefix: 'field',
    key: 'assist.field.error.valid',
    rule: regex,
  },
  required: {
    prefix: 'field',
    key: 'assist.field.error.required',
    rule: required,
  },
  max: {
    prefix: 'field',
    key: 'assist.field.error.max',
    rule: max,
  },
} as Record<string, CustomRuleDefinition>

export default () => {
  // Defined following rules globally
  defineRule('required', required)
  defineRule('min', min)
  defineRule('min_value', min_value)
  defineRule('max', max)
  defineRule('numeric', numeric)
  defineRule('one_of', one_of)
  defineRule('confirmed', confirmed)
  defineRule('email', email)
  defineRule('entity_code', entityCodeRule)
  defineRule('must_be_number', numberRule)
  defineRule('phone', phoneRule)
}

const convertI18nLabelIntoVeevalidateFormat = () => {
  const i18nMessages = i18n.global.getLocaleMessage(i18n.global.locale.value) as Record<string, string>
  const messages: i18nTranslation = {}
  for (const messageKey in i18nMessages) {
    if (messageKey.startsWith(PrefixTranslationsEnum.VEEVALIDATE)) {
      const ruleKey = messageKey.replace(`${PrefixTranslationsEnum.VEEVALIDATE}.`, '')
      messages[ruleKey] = i18nMessages[messageKey]
    }
  }

  for (const [name, { prefix, key, rule }] of Object.entries(CUSTOM_RULES)) {
    const ruleName = `${prefix}_${name}`
    messages[ruleName] = i18nMessages[key]
    defineRule(ruleName, rule)
  }

  messages['phone'] = i18nMessages['assist.field.error.valid']

  return messages
}

export const initFormValidation = async (locale: string) => {
  const messages = convertI18nLabelIntoVeevalidateFormat()

  configure({
    generateMessage: localize(locale, {
      messages,
    }),
  })
}
